<!-- 데스크톱 레이아웃 -->
<main class="hidden lg:flex flex-col w-full bg-zinc-50 pt-30 pb-15">
  <div class="flex flex-col gap-6 mx-auto max-w-6xl w-full">
    <h1 class="text-2xl text-zinc-800 text-center">사전 관람 등록</h1>

    <div class="flex flex-col lg:flex-row gap-6 w-full lg:items-start">
      <!-- 왼쪽: 폼 컨텐츠 -->
      <div class="flex-2 flex flex-col gap-6 lg:max-h-[calc(100vh-240px)] lg:overflow-y-auto scrollbar-hide">
        <app-registration-info [form]="form" [events]="events()" />
      </div>

      <!-- 오른쪽: 고정 사이드바 -->
      <div
        class="hidden lg:flex sticky top-24 flex-1 flex-col gap-6 bg-white rounded-2xl p-8 border border-zinc-100 self-start max-h-[calc(100vh-120px)] overflow-y-auto">
        <app-registration-price-info
          [(allAgreed)]="allAgreed"
          (allAgreedChange)="toggleAllAgreed($event)"
          [(isTermsAgreed)]="isTermsAgreed"
          [(isPrivacyAgreed)]="isPrivacyAgreed"
          (openPolicy)="openPolicyModal($event)" />

        <!-- 액션 버튼 -->
        <app-registration-action-buttons
          class="flex lg:flex-col gap-2"
          [canSubmit]="canSubmit()"
          (submitForm)="submit()"
          (goBack)="goBack()" />
      </div>
    </div>
  </div>
</main>

<!-- 모바일 레이아웃 -->
<app-page-modal-container class="lg:hidden">
  <main class="pb-20">
    <div class="flex flex-col gap-6 p-4">
      <app-registration-info [form]="form" [events]="events()" />

      <!-- 모바일 금액 정보 -->
      <div class="border border-zinc-100 rounded-2xl bg-white p-5">
        <app-registration-price-info
          [(allAgreed)]="allAgreed"
          (allAgreedChange)="toggleAllAgreed($event)"
          [(isTermsAgreed)]="isTermsAgreed"
          [(isPrivacyAgreed)]="isPrivacyAgreed"
          (openPolicy)="openPolicyModal($event)" />
      </div>
    </div>
  </main>

  <!-- 모바일 하단 고정 버튼 -->
  <div class="flex gap-3 p-4" footer>
    <app-registration-action-buttons [canSubmit]="canSubmit()" (submitForm)="submit()" (goBack)="goBack()" />
  </div>
</app-page-modal-container>
